/**
 * DECISIONS 402 (GameConfig.finiteSupply): taking magazines and bandages out of a side's stock — its standing containers, in
 * order. Kept apart from core/supplyStock.ts, which reads the motor pool's plan: core/convoys.ts loads from here, and its
 * import of supplyStock closed a cycle back to core/modules (tests/motorPoolLoadOrder.test.ts).
 */
import type { GameState } from '../types';

/** Take up to `want` from side `team`'s standing containers, in order: what it got, and the stocks after. */
export function takeStock<S extends Pick<GameState, 'supplyStocks'>>(state: S, team: number, want: { magazines?: number; bandages?: number }): { state: S; magazines: number; bandages: number } {
  const stock = state.supplyStocks?.[team];
  if (!stock) return { state, magazines: 0, bandages: 0 };
  let m = Math.max(0, want.magazines ?? 0), b = Math.max(0, want.bandages ?? 0), gotM = 0, gotB = 0;
  const next = stock.map(c => {
    if (c.health <= 0 || (m <= 0 && b <= 0)) return c;
    const tm = Math.min(m, c.magazines), tb = Math.min(b, c.bandages);
    if (tm <= 0 && tb <= 0) return c;
    m -= tm; b -= tb; gotM += tm; gotB += tb;
    return { ...c, magazines: c.magazines - tm, bandages: c.bandages - tb };
  });
  if (gotM <= 0 && gotB <= 0) return { state, magazines: 0, bandages: 0 };
  return { state: { ...state, supplyStocks: { ...state.supplyStocks, [team]: next } }, magazines: gotM, bandages: gotB };
}
